import { Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { booleanToHighLow } from './BooleanToHighLow';

export function ArmsResult({ model1Result, title, vertical }) {
  const { t } = useTranslation();
  const scoreItem = (heading, value) => {
    return (
      <Stack justifyContent="space-between" spacing={2} direction="row">
        <Typography>{heading}</Typography>
        <Typography>{t(value)}</Typography>
      </Stack>
    );
  };

  return (
    <>
      {vertical ? (
        <Paper sx={{ padding: 2 }}>
          <Stack spacing={1}>
            {scoreItem('Probability of left arm weakness', booleanToHighLow(model1Result.leftArmsScore))}
            {scoreItem('Probability of right arm weakness', booleanToHighLow(model1Result.rightArmsScore))}
          </Stack>
        </Paper>
      ) : (
        <Paper sx={{ width: '800px', padding: 2 }}>
          <Stack spacing={1} direction="row" justifyContent="space-between">
            {scoreItem('Probability of left arm weakness', booleanToHighLow(model1Result.leftArmsScore))}
            {scoreItem('Probability of right arm weakness', booleanToHighLow(model1Result.rightArmsScore))}
          </Stack>
        </Paper>
      )}
    </>
  );
}
